import { TAffiliateFirm } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useAffiliateFirm(affiliateFirmId: string) {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data?: { affiliateFirm: TAffiliateFirm };
    error?: unknown;
    isLoading: boolean;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    affiliateFirmId ? `affiliate-firms/${affiliateFirmId}` : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    isLoading,
    mutate,
  };
}
